import React, { useEffect, useRef, useState } from "react";
import { matchRoutes, Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom";
import AudiosDetailPage from "../Pages/AudioPlayerPage";
import FooterPage from "./FooterPage";
import HeaderPage from "./HeaderPage";
// import BooksPage from "../Pages/BooksPage";
import BookDetailPage from "../Pages/BookDetailPage";
// import EpubPage from "../Pages/Epub";
import KalyansPage from "../Pages/KalyansPage";
import KalyanDetailPage from "../Pages/KalyanDetailPage";
import PravachansPage from "../Pages/PravachansPage";
import AudiosPage from "../Pages/AudiosPage";
import ArticlesPage from "../Pages/ArticlesPage";
import ArticlesDetailPage from "../Pages/ArticlesDetail";
import KalpataruPage from "../Pages/KalpataruPage";
import KalpataruDetailPage from "../Pages/KalpataruDetailPage";
import GeetgovindPage from "../Pages/GeetgovindPage";
import GeetGovindDetailPage from "../Pages/GeetGovindDetailPage";
import PrivacyPage from "../Pages/PrivacyPolicyPage";
import TearmsOfUsePage from "../Pages/TermsOfUsePage";
import FaqPage from "../Pages/FaqPage";
import AuthorsDataPage from "../Pages/AuthorsPage";
import SearchDataPage from "../Pages/SearchDataPage";
import { ProfileFav } from "../Pages/ProfileFav";
import { ProfileContact } from "../Pages/ProfileContact";
import VivekvaniPage from "../Pages/VivekVani";
import DivineQuotes from "../Pages/DivineQuotePage";
import DailySatsangPage from "../Pages/DailySatsang";
import PromotionPage from "../Pages/PromotionPage";
import PDFViewer from "../Pages/PDFViewer";
import FullImage from "../Pages/FullImage";
import NewLoginPage from "../Pages/NewLoginPage";
import VideoPlayerPage from "../Pages/VideoPlayerPage";
import MaintencePage from "../Pages/MaintencePage";
import InternetPage from "../Pages/NoInternetConnection"
import WebViewforbook from "../Pages/WebView";
import VivekvaniDetailPage from "../Pages/VivekvaniDetailPage";
import MagazineLandingPage from "../Pages/MagazineLandingPage";
import AudioLandingPage from "../Pages/AudioLandingPage";
import AppDownloadPopup from "../Components/AppDownloadPopup";
import VideoLandingPage from "../Pages/VideoLandingPage";

// Mobile components from ResponsivePages
import { MobileHome } from "../Pages/ResponsivePages/MobileHome";
import MobileAboutUs from "../Pages/ResponsivePages/MobileAboutUs";
import MobileEBooks from "../Pages/ResponsivePages/MobileEBooks";
import MobileBookPage from "../Pages/ResponsivePages/MobileBookPage";
import MobileBooksRoute from "../Pages/ResponsivePages/MobileBooksRoute";
import MobileEpub from "../Pages/ResponsivePages/Common/MobileEpub";
import MobileMagazines from "../Pages/ResponsivePages/MobileMagazines";
import MobileKalyansPage from "../Pages/ResponsivePages/MobileKalyansPage";
import MobilePravachans from "../Pages/ResponsivePages/MobilePravachans";
import MobileAudioListPage from "../Pages/ResponsivePages/MobileAudioListPage";
import MbAudioPlayerPage from "../Pages/ResponsivePages/Common/MbAudioPlayerPage";
import MbAllVideos from "../Pages/ResponsivePages/MbAllVideos";
import MobileArticlesPage from "../Pages/ResponsivePages/MobileArticlesPage";
import MobileDivineQuotes from "../Pages/ResponsivePages/MobileDivineQuotes";
import MobileProfilePage from "../Pages/ResponsivePages/MobileProfilePage";
import MobileFavoriatePage from "../Pages/ResponsivePages/MobileFavoriatePage";
import MobilePrivacyPolicy from "../Pages/ResponsivePages/MobilePrivacyPolicy";
import MobileTermsOfUse from "../Pages/ResponsivePages/MobileTermsOfUse";
import MobileLoginPage from "../Pages/ResponsivePages/LoginPage";

// Additional mobile components
import MobileReadEBooksPage from "../Pages/ResponsivePages/MobileReadEBooksPage";
import MobileBooksFilterPage from "../Pages/ResponsivePages/MobileBooksFilterPage";
import DivineQuotesImageview from "../Pages/ResponsivePages/DivineQuotesImageview";
import FilteredSubjectData from "../Pages/ResponsivePages/FilteredSubjectData";
import MobileRecentlyViewed from "../Pages/ResponsivePages/MobileRecentlyViewed";
import ReadArticles from "../Pages/ResponsivePages/Common/ReadArticles";
import MobilePromotion from "../Pages/ResponsivePages/MobilePromotion";
import LegendsIntroduction from "../Pages/ResponsivePages/LegendsIntroduction";
import MbAudioCategory from "../Pages/ResponsivePages/MbAudioCategory";
import MbVideoParentCategory from "../Pages/ResponsivePages/MbVideoParentCategory";
import CategoriesFilter from "../Pages/ResponsivePages/CategoriesFilter";
import MobileEnglishTemplate from "../Pages/ResponsivePages/MobileEnglishTemplate";
import MobileHindiTemplate from "../Pages/ResponsivePages/MobileHindiTemplate";

// Hook
import { useIsMobile } from "../hooks/useIsMobile";

const HomePage = React.lazy(
  () => import("../Pages/HomePage" /* webpackChunkName: "home" */)
);

const AboutPage = React.lazy(
  () => import("../Pages/AboutPage")
)

const Profile = React.lazy(
  () => import("../Pages/Profile" /* webpackChunkName: "home" */)
);

const EpubPage = React.lazy(
  () => import("../Pages/Epub" /* webpackChunkName: "epub" */)
);

const BooksPage = React.lazy(
  () => import("../Pages/BooksPage" /* webpackChunkName: "epub" */)
);

const TestPage = React.lazy(
  () => import("../Pages/TestPage")
);
const WithHeaderFooter = ({ element }: { element: any }) => {
  const [showAppPopup, setShowAppPopup] = useState(false);
  const [containerLeft, setContainerLeft] = useState(0);
  const [bannerTop, setBannerTop] = useState(0);

  const measureAndShow = () => {
    if (window.innerWidth >= 1200) {
      const containers = document.querySelector('.containers');
      const header = document.querySelector('.gst-header');
      if (containers) {
        setContainerLeft(containers.getBoundingClientRect().left);
      }
      if (header) {
        setBannerTop(header.getBoundingClientRect().bottom + 12);
      } else {
        setBannerTop(180);
      }
      setShowAppPopup(true);
    }
  };

  useEffect(() => {
    const shouldShow = sessionStorage.getItem('showAppPopup');
    if (shouldShow) {
      measureAndShow();
    }
  }, []);

  useEffect(() => {
    const handler = () => measureAndShow();
    window.addEventListener('appPopupReady', handler);
    return () => window.removeEventListener('appPopupReady', handler);
  }, []);

  return (
    <>
      <div
        style={{
          width: "100vw",
          minHeight: "100vh",
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
      >
        <HeaderPage />
        {element}
        <FooterPage />
      </div>
      {/* <AppDownloadPopup
        show={showAppPopup}
        containerLeft={containerLeft}
        bannerTop={bannerTop}
        onClose={() => {
          setShowAppPopup(false);
          sessionStorage.removeItem('showAppPopup');
        }}
      /> */}
    </>
  );
};

// const NotFoundRedirect = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const lastValidPath = useRef("/");

//   useEffect(() => {
//     // 👇 build route definitions directly from your JSX (no duplication)
//     const routes = [
//       { path: "/fullimage" },
//       { path: "/" },
//       { path: "/home" },
//       { path: "/about" },
//       { path: "/books" },
//       { path: "/books/special" },
//       { path: "/books/author/:id" },
//       { path: "/books/language/:langid" },
//       { path: "/books/category/:catid" },
//       { path: "/books/:bookid" },
//       { path: "/books/special/:bookid" },
//       { path: "/books/author/:authorId/:bookid" },
//       { path: "/books/language/:langId/:bookid" },
//       { path: "/books/category/:catId/:bookid" },
//       { path: "/reader/:type/:id" },
//       { path: "/vivekvani" },
//       { path: "/vivekvani/special" },
//       { path: "/vivekvani/author/:id" },
//       { path: "/vivekvani/language/:langid" },
//       { path: "/vivekvani/:cat/:langid" },
//       { path: "/vivekvani/:vaniid" },
//       { path: "/vivekvani/special/:vaniid" },
//       { path: "/vivekvani/author/:id/:vaniid" },
//       { path: "/vivekvani/category/:catid" },
//       { path: "/vivekvani/language/:langid" },
//       { path: "/kalyan" },
//       { path: "/kalyan/category/:catid" },
//       { path: "/kalyan/special" },
//       { path: "/kalyan/author/:id" },
//       { path: "/kalyan/language/:langid" },
//       { path: "/kalyan/:kalyanid" },
//       { path: "/kalyan/special/:kalyanid" },
//       { path: "/kalyan/author/:id/:kalyanid" },
//       { path: "/kalyan/category/:catid/:kalyanid" },
//       { path: "/kalyan/language/:langid/:kalyanid" },
//       { path: "/kalyanakalpataru" },
//       { path: "/kalyanakalpataru/category/:catid" },
//       { path: "/kalyanakalpataru/special" },
//       { path: "/kalyanakalpataru/author/:id" },
//       { path: "/kalyanakalpataru/language/:langid" },
//       { path: "/kalyanakalpataru/:kalyanid" },
//       { path: "/kalyanakalpataru/special/:kalyanid" },
//       { path: "/kalyanakalpataru/author/:id/:kalyanid" },
//       { path: "/kalyanakalpataru/category/:catid/:kalyanid" },
//       { path: "/kalyanakalpataru/language/:langid/:kalyanid" },
//       { path: "/geetgovind" },
//       { path: "/geetgovind/category/:catid" },
//       { path: "/geetgovind/special" },
//       { path: "/geetgovind/author/:id" },
//       { path: "/geetgovind/language/:langid" },
//       { path: "/geetgovind/:id" },
//       { path: "/geetgovind/special/:id" },
//       { path: "/geetgovind/author/:id" },
//       { path: "/geetgovind/category/:catid/:id" },
//       { path: "/geetgovind/language/:langid/:id" },
//       { path: "/pravachans" },
//       { path: "/pravachans/special" },
//       { path: "/pravachans/author/:id" },
//       { path: "/pravachans/:id" },
//       { path: "/pravachans/:cat/:id" },
//       { path: "/audios" },
//       { path: "/audios/special" },
//       { path: "/audios/author/:id" },
//       { path: "/audios/:id" },
//       { path: "/audios/:cat/:id" },
//       { path: "/DailySatsang/:id" },
//       { path: "/DailySatsang" },
//       { path: "/videos" },
//       { path: "/videos/author/:id" },
//       { path: "/videos/category/:id" },
//       { path: "/videos/video/:id" },
//       { path: "/articles" },
//       { path: "/articles/special" },
//       { path: "/articles/author/:id" },
//       { path: "/articles/:id" },
//       { path: "/articles/special/:id" },
//       { path: "/articles/author/:id/:articleid" },
//       { path: "/divinequotes" },
//       { path: "/privacypolicy" },
//       { path: "/termsofuse" },
//       { path: "/faq" },
//       { path: "/promotion" },
//       { path: "/author/:id" },
//       { path: "/searchdata/:searchCategory/:search" },
//       { path: "/searchdata/:searchCategory/" },
//       { path: "/searchdata/:searchCategory/*" },
//       { path: "/profile/" },
//       { path: "/profile/My-Favourites" },
//       { path: "/profile/feedback" },
//       { path: "/pdf-viewer" },
//     ];

//     const matches = matchRoutes(routes, location);

//     if (matches) {
//       lastValidPath.current = location.pathname;
//     } else {
//       navigate(-1 as any);
//       // navigate(-1 as any, { replace: true });
//       // navigate(lastValidPath.current, { replace: true });
//     }
//   }, [location, navigate]);

//   return null;
// };


const AppRoutes = () => {
  const isMobile = useIsMobile();

  return (
    <Routes>

      <Route element={<WebViewforbook />} path="/webView"></Route>
      {/* full image path */}
      <Route element={<FullImage />} path="/fullimage"></Route>

      {/* Home */}
      <Route
        element={
          isMobile
            ? <MobileHome />
            : <WithHeaderFooter element={<HomePage />} />
        }
        path="/"
      />

      {/* About */}
      <Route
        element={
          isMobile
            ? <MobileAboutUs />
            : <WithHeaderFooter element={<AboutPage />} />
        }
        path="/about"
      ></Route>

      {/* Magazine Landing */}
      <Route
        element={
          isMobile
            ? <MobileMagazines />
            : <WithHeaderFooter element={<MagazineLandingPage />} />
        }
        path="/magazines"
      ></Route>
      <Route
        element={<Navigate to="/magazines" replace />}
        path="/magazine"
      ></Route>

      {/* Audio Landing */}
      <Route
        element={<WithHeaderFooter element={<AudioLandingPage />} />}
        path="/Audio"
      ></Route>

      {/* Books */}
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<BooksPage />} />
        }
        path="/books"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<TestPage />} />}
        path="/test"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<BooksPage />} />
        }
        path="/books/special"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<BooksPage />} />
        }
        path="/books/author/:id"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<BooksPage />} />
        }
        path="/books/language/:langid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<BooksPage />} />
        }
        path="/books/category/:catid"
      ></Route>

      {/* Redirects from old mobile-only routes to unified routes */}
      <Route element={<Navigate to="/books" replace />} path="/mbBooks" />
      <Route element={<Navigate to="/books" replace />} path="/readEBooks" />
      <Route element={<Navigate to="/books" replace />} path="/eBooks" />
      <Route element={<Navigate to="/videos" replace />} path="/video" />
      <Route element={<Navigate to="/videos" replace />} path="/allVideos" />
      <Route element={<Navigate to="/magazines" replace />} path="/mobileMagazines" />
      <Route element={<Navigate to="/magazines/kalyan" replace />} path="/mobileKalyans" />
      <Route element={<Navigate to="/pravachans" replace />} path="/mobilePravachans" />

      {/* Mobile-only routes */}
      {isMobile && (
        <>
          <Route element={<MobileBooksFilterPage />} path="/filter" />
          <Route element={<MobileFavoriatePage />} path="/myFavourite" />
          <Route element={<MobileProfilePage />} path="/myProfile" />
          <Route element={<MobileDivineQuotes />} path="/divineQuotes" />
          <Route element={<DivineQuotesImageview />} path="/divineQuotesImg" />

          <Route element={<FilteredSubjectData />} path="/subjectData" />
          <Route element={<MobileRecentlyViewed />} path="/recentlyViewed" />
          <Route element={<ReadArticles />} path="/readArticles" />
          <Route element={<MobileLoginPage />} path="/loginPage" />

          <Route element={<MobileAudioListPage />} path="/mobileAudioListPage" />
          <Route element={<CategoriesFilter />} path="/categoriesFilter" />
          <Route element={<MbAudioPlayerPage />} path="/audioPlayerPage" />
          <Route element={<MbAudioCategory />} path="/mbAudioCategory" />
          <Route element={<MobileArticlesPage />} path="/mobileArticles" />
          <Route element={<MobileTermsOfUse />} path="/terms-of-use" />
          <Route element={<MobilePrivacyPolicy />} path="/privacy-policy" />
          <Route element={<MobilePromotion />} path="/publicity" />
          <Route element={<MobileEnglishTemplate />} path="/pamphletEng" />
          <Route element={<MobileHindiTemplate />} path="/pamphletHindi" />
          <Route element={<LegendsIntroduction />} path="/legendsIntroduction" />
          <Route element={<MobileEBooks />} path="/eBooks" />
        </>
      )}

      {/* Book Detail */}
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<BookDetailPage />} />
        }
        path="/books/:bookid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<BookDetailPage />} />
        }
        path="/books/:slug"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<BookDetailPage />} />
        }
        path="/books/special/:bookid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<BookDetailPage />} />
        }
        path="/books/author/:authorId/:slug"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<BookDetailPage />} />
        }
        path="/books/language/:langId/:slug"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<BookDetailPage />} />
        }
        path="/books/category/:catId/:slug"
      ></Route>

      {/* epub */}
      <Route element={
        isMobile
          ? <MobileEpub />
          : <React.Suspense fallback={<div>Loading...</div>}>
              <EpubPage />
            </React.Suspense>
      } path="reader/:type/:id"></Route>

      {/* vivekvani listing */}
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<VivekvaniPage />} />
        }
        path="/magazines/vivekvani"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<VivekvaniPage />} />
        }
        path="/magazines/vivekvani/special"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<VivekvaniPage />} />
        }
        path="/magazines/vivekvani/author/:id"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<VivekvaniPage />} />
        }
        path="/magazines/vivekvani/language/:langid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileBooksRoute />
            : <WithHeaderFooter element={<VivekvaniPage />} />
        }
        path="/magazines/vivekvani/:cat/:langid"
      ></Route>

      {/* Vivek Vani Detail — desktop only */}
      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/magazines/vivekvani/:slug"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/magazines/vivekvani/special/:vaniid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/magazines/vivekvani/author/:id/:vaniid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/magazines/vivekvani/category/:catid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/magazines/vivekvani/language/:langid"
      ></Route>

      {/* Kalyan */}
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalyansPage />} />
        }
        path="/magazines/kalyan"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalyansPage />} />
        }
        path="/magazines/kalyan/category/:catid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalyansPage />} />
        }
        path="/magazines/kalyan/special"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalyansPage />} />
        }
        path="/magazines/kalyan/author/:id"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalyansPage />} />
        }
        path="/magazines/kalyan/language/:langid"
      ></Route>

      {/* Kalyan Detail */}
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/magazines/kalyan/:slug"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/magazines/kalyan/special/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/magazines/kalyan/author/:id/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/magazines/kalyan/category/:catid/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/magazines/kalyan/language/:langid/:kalyanid"
      ></Route>

      {/* Kalyanakalpataru Page */}
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalpataruPage />} />
        }
        path="/magazines/kalyanakalpataru"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalpataruPage />} />
        }
        path="/magazines/kalyanakalpataru/category/:catid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalpataruPage />} />
        }
        path="/magazines/kalyanakalpataru/special"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalpataruPage />} />
        }
        path="/magazines/kalyanakalpataru/author/:id"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileKalyansPage />
            : <WithHeaderFooter element={<KalpataruPage />} />
        }
        path="/magazines/kalyanakalpataru/language/:langid"
      ></Route>

      {/* Kalpataru Detail */}
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<KalpataruDetailPage />} />
        }
        path="/magazines/kalyanakalpataru/:slug"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<KalpataruDetailPage />} />
        }
        path="/magazines/kalyanakalpataru/special/:kalyanid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<KalpataruDetailPage />} />
        }
        path="/magazines/kalyanakalpataru/author/:id/:kalyanid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<KalpataruDetailPage />} />
        }
        path="/magazines/kalyanakalpataru/category/:catid/:kalyanid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<KalpataruDetailPage />} />
        }
        path="/magazines/kalyanakalpataru/language/:langid/:kalyanid"
      ></Route>

      {/* Geet Govind Page */}
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetgovindPage />} />
        }
        path="/magazines/geetgovind"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetgovindPage />} />
        }
        path="/magazines/geetgovind/:lang"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetgovindPage />} />
        }
        path="/magazines/geetgovind/category/:catid"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetgovindPage />} />
        }
        path="/magazines/geetgovind/special"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetgovindPage />} />
        }
        path="/magazines/geetgovind/author/:id"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetgovindPage />} />
        }
        path="/magazines/geetgovind/language/:langid"
      ></Route>

      {/* GeetGovindDetailPage */}
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetGovindDetailPage />} />
        }
        path="/magazines/geetgovind/:slug/:lang?"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetGovindDetailPage />} />
        }
        path="/magazines/geetgovind/special/:id/:lang?"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetGovindDetailPage />} />
        }
        path="/magazines/geetgovind/category/:catid/:id/:lang?"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileReadEBooksPage />
            : <WithHeaderFooter element={<GeetGovindDetailPage />} />
        }
        path="/magazines/geetgovind/language/:langid/:id/:lang?"
      ></Route>

      {/* pravachan page */}
      <Route
        element={
          isMobile
            ? (() => {
                const MobilePravachanWrapper = () => {
                  const location = useLocation();
                  return (location.state as { type?: string })?.type === "pravachans"
                    ? <MobileAudioListPage />
                    : <MobilePravachans />;
                };
                return <MobilePravachanWrapper />;
              })()
            : <WithHeaderFooter element={<PravachansPage />} />
        }
        path="/pravachans"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobilePravachans />
            : <WithHeaderFooter element={<PravachansPage />} />
        }
        path="/pravachans/special"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobilePravachans />
            : <WithHeaderFooter element={<PravachansPage />} />
        }
        path="/pravachans/author/:id"
      ></Route>

      {/* pravachan detail page */}
      <Route element={<AudiosDetailPage />} path="/pravachans/:id"></Route>
      <Route element={<AudiosDetailPage />} path="/pravachans/:cat/:id"></Route>

      {/* audio page */}
      <Route
        element={
          isMobile
            ? (() => {
                const MobileAudioWrapper = () => {
                  const location = useLocation();
                  return (location.state as { categoryId?: unknown })?.categoryId !== undefined
                    ? <MobileAudioListPage />
                    : <MbAudioCategory />;
                };
                return <MobileAudioWrapper />;
              })()
            : <WithHeaderFooter element={<AudiosPage />} />
        }
        path="/audios"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileAudioListPage />
            : <WithHeaderFooter element={<AudiosPage />} />
        }
        path="/audios/special"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileAudioListPage />
            : <WithHeaderFooter element={<AudiosPage />} />
        }
        path="/audios/author/:id"
      ></Route>

      {/* audio player page */}
      <Route element={
        isMobile
          ? <MbAudioPlayerPage />
          : <AudiosDetailPage />
      } path="/audios/:slug"></Route>
      <Route element={
        isMobile
          ? <MbAudioPlayerPage />
          : <AudiosDetailPage />
      } path="/audios/:id"></Route>
      <Route element={
        isMobile
          ? <MbAudioPlayerPage />
          : <AudiosDetailPage />
      } path="/audios/:cat/:id"></Route>
      <Route element={<AudiosDetailPage />} path="/DailySatsang/:slug"></Route>
      <Route element={<AudiosDetailPage />} path="/DailySatsang/:id"></Route>
      <Route element={<AudiosDetailPage />} path="/DailySatsang/*"></Route>

      {/* daily satsang page */}
      <Route
        element={
          isMobile
            ? (() => {
                const MobileDailySatsangWrapper = () => {
                  const location = useLocation();
                  return (location.state as { type?: string })?.type === "DailySatsang"
                    ? <MobileAudioListPage />
                    : <DailySatsangPage />;
                };
                return <MobileDailySatsangWrapper />;
              })()
            : <WithHeaderFooter element={<DailySatsangPage />} />
        }
        path="/DailySatsang"
      ></Route>

      {/* video player page */}
      <Route
        element={
          isMobile
            ? <MbAllVideos />
            : <WithHeaderFooter element={<VideoPlayerPage />} />
        }
        path="/videos"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VideoLandingPage />} />}
        path="/videos/:slug"
      ></Route>
      <Route
        element={
          isMobile
            ? <MbAllVideos />
            : <WithHeaderFooter element={<VideoPlayerPage />} />
        }
        path="/videos/author/:id"
      ></Route>
      <Route
        element={
          isMobile
            ? <MbAllVideos />
            : <WithHeaderFooter element={<VideoPlayerPage />} />
        }
        path="/videos/category/:id"
      ></Route>
      <Route
        element={
          isMobile
            ? <MbAllVideos />
            : <WithHeaderFooter element={<VideoPlayerPage />} />
        }
        path="/videos/video/:id"
      ></Route>

      {/* article page */}
      <Route
        element={
          isMobile
            ? <MobileArticlesPage />
            : <WithHeaderFooter element={<ArticlesPage />} />
        }
        path="/articles"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileArticlesPage />
            : <WithHeaderFooter element={<ArticlesPage />} />
        }
        path="/articles/special"
      ></Route>
      <Route
        element={
          isMobile
            ? <MobileArticlesPage />
            : <WithHeaderFooter element={<ArticlesPage />} />
        }
        path="/articles/author/:id"
      ></Route>

      {/* article detail page */}
      <Route
        element={<WithHeaderFooter element={<ArticlesDetailPage />} />}
        path="/articles/:slug"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<ArticlesDetailPage />} />}
        path="/articles/special/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<ArticlesDetailPage />} />}
        path="/articles/author/:id/:articleid"
      ></Route>

      {/* Divine Quotes Page */}
      <Route
        element={
          isMobile
            ? <MobileDivineQuotes />
            : <WithHeaderFooter element={<DivineQuotes />} />
        }
        path="/divinequotes"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<DivineQuotes />} />}
        path="/divinequotes/:id"
      ></Route>

      {/* Privacy Policy */}
      <Route
        element={
          isMobile
            ? <MobilePrivacyPolicy />
            : <WithHeaderFooter element={<PrivacyPage />} />
        }
        path="/privacypolicy"
      ></Route>

      {/* Terms of Use */}
      <Route
        element={
          isMobile
            ? <MobileTermsOfUse />
            : <WithHeaderFooter element={<TearmsOfUsePage />} />
        }
        path="/termsofuse"
      ></Route>

      {/* FAQ — desktop only */}
      <Route
        element={<WithHeaderFooter element={<FaqPage />} />}
        path="/faq"
      ></Route>

      {/* Promotion — desktop only */}
      <Route
        element={<WithHeaderFooter element={<PromotionPage />} />}
        path="/promotion"
      ></Route>

      {/* Author — desktop only */}
      <Route
        element={<WithHeaderFooter element={<AuthorsDataPage />} />}
        path="/author/:id"
      ></Route>

      {/* Search — desktop only */}
      <Route
        element={<WithHeaderFooter element={<SearchDataPage />} />}
        path="/searchdata/:searchCategory/:search"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<SearchDataPage />} />}
        path="/searchdata/:searchCategory/"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<SearchDataPage />} />}
        path="/searchdata/:searchCategory/*"
      ></Route>

      {/* Profile */}
      <Route
        element={
          isMobile
            ? <MobileProfilePage />
            : <WithHeaderFooter element={<Profile />} />
        }
        path="/profile/"
      ></Route>

      {/* Login */}
      <Route
        element={
          isMobile
            ? <MobileLoginPage />
            : <NewLoginPage />
        }
        path="/Login/*"
      ></Route>

      {/* Profile Favourites */}
      <Route
        element={
          isMobile
            ? <MobileFavoriatePage />
            : <WithHeaderFooter element={<ProfileFav />} />
        }
        path="/profile/My-Favourites"
      ></Route>

      {/* Profile Feedback — desktop only */}
      <Route
        element={<WithHeaderFooter element={<ProfileContact />} />}
        path="/profile/feedback"
      ></Route>

      {/* Pdf Viewer — desktop only */}
      <Route element={<PDFViewer />} path="/pdf-viewer"></Route>

      {/* fallback: redirect unknown URLs back to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
export default AppRoutes;
